<div class="ion-padding afh">
  <h2><ion-icon name="people-outline"></ion-icon> Felhasználók és cégek</h2>
  <p class="halvany" *ngIf="adat">
    <ng-container *ngIf="kapcsolt">A Könyvelésből a kiosztás minden összekötött modulra érvényes: <b>{{ celNevek }}</b>.</ng-container>
    <ng-container *ngIf="!kapcsolt">A kiosztás erre a modulra szól: <b>{{ celNevek }}</b>{{ adat.mod === 'onallo' ? ' (önálló ügyfélkör)' : adat.mod === 'kapcsolt' ? ' (a Könyvelés ügyfeleivel – a többi modulra a Könyvelésből osztható ki)' : '' }}.</ng-container>
    <br><b>Ügyfél</b> – a cég saját embere: a kiosztott cégek nevében dolgozik{{ adat.ugyfeloldal.length ? '' : ' (ebben a modulban nincs ügyféloldal)' }}.
    <b>Munkatárs</b> – az iroda kollégája a választott jogkörrel; ha cégeket kap, csak azokat látja, cég nélkül mindet.
  </p>
  <div class="afh-hiba" *ngIf="hiba">{{ hiba }}</div>

  <!-- AZ ÚJ FELHASZNÁLÓ BELÉPÉSI ADATAI -->
  <section class="afh-kartya afh-eredmeny" *ngIf="eredmeny?.fiok">
    <h3>{{ eredmeny.jelszoCsere ? 'Új jelszó' : 'Felvéve' }}: {{ eredmeny.nev }}</h3>
    <ng-container [ngSwitch]="true">
      <div *ngSwitchCase="!!eredmeny.fiok.jelszo">
        Felhasználónév: <code>{{ eredmeny.fiok.username }}</code> &nbsp;
        Ideiglenes jelszó: <code>{{ eredmeny.fiok.jelszo }}</code>
        <button type="button" class="afh-link" (click)="masol(eredmeny.fiok.username + ' / ' + eredmeny.fiok.jelszo)">másolás</button>
        <small>Csak most látszik – add át a felhasználónak. {{ eredmeny.fiok.tipus === 'keycloak' ? 'Az első belépéskor új jelszót kér.' : '' }}
          {{ eredmeny.fiok.level ? 'A belépési adatokat elküldtük: ' + eredmeny.fiok.level + '.' : '' }}
          {{ eredmeny.fiok.level_hiba || '' }}</small>
      </div>
      <div *ngSwitchCase="!!eredmeny.fiok.letezik">{{ eredmeny.fiok.uzenet }} (Új jelszó a listában adható.)</div>
      <div *ngSwitchCase="!!eredmeny.fiok.hiba" class="afh-hiba">A felhasználó létrejött, de a belépési fiók nem: {{ eredmeny.fiok.hiba }}</div>
      <div *ngSwitchDefault>{{ eredmeny.fiok.uzenet || 'Kész.' }}</div>
    </ng-container>
    <small *ngIf="eredmeny.meglevo">Ehhez az e-mail címhez már volt személy a nyilvántartásban ({{ eredmeny.felhasznalo }}) – őt kötöttük be.</small>
  </section>

  <ng-container *ngIf="adat">
    <!-- ŰRLAP -->
    <section class="afh-kartya" *ngIf="urlap">
      <h3>{{ urlap.uj ? 'Új felhasználó' : urlap.nev }}</h3>
      <div class="afh-racs" *ngIf="urlap.uj">
        <label>Vezetéknév <input [(ngModel)]="urlap.vezeteknev" autocomplete="off"></label>
        <label>Keresztnév <input [(ngModel)]="urlap.keresztnev" autocomplete="off"></label>
        <label>E-mail cím <input type="email" [(ngModel)]="urlap.email" autocomplete="off" placeholder="a belépési adatokhoz"></label>
        <label>Felhasználónév <input [(ngModel)]="urlap.felhasznalonev" autocomplete="off" placeholder="üresen: vezeteknev.keresztnev"></label>
        <label *ngIf="adat.belepes === 'helyi'">Jelszó <input type="text" [(ngModel)]="urlap.jelszo" autocomplete="off" placeholder="üresen: generált"></label>
      </div>
      <div class="afh-fajta">
        <label><input type="radio" name="fajta" value="munkatars" [(ngModel)]="urlap.fajta"> <b>Munkatárs</b> – az iroda kollégája</label>
        <label [class.tiltott]="!adat.ugyfeloldal.length"><input type="radio" name="fajta" value="ugyfel" [(ngModel)]="urlap.fajta" [disabled]="!adat.ugyfeloldal.length">
          <b>Ügyfél</b> – a cég saját embere</label>
      </div>

      <div class="afh-jogkorok" *ngIf="urlap.fajta === 'munkatars'">
        <label *ngFor="let c of adat.celok">{{ c.nev }}
          <select [(ngModel)]="urlap.jogkorok[c.alr]">
            <option value="">— nincs joga —</option>
            <option *ngFor="let j of jogkorOpciok(c.alr)" [value]="j.jogkor">{{ j.nev }}</option>
          </select>
        </label>
      </div>
      <p class="halvany" *ngIf="urlap.fajta === 'ugyfel'">Az ügyfél ezekben dolgozik a kiosztott cégek nevében: {{ adat.ugyfeloldal.length ? '' : 'nincs ügyféloldali modul.' }}
        <ng-container *ngFor="let c of adat.celok; let last = last"><ng-container *ngIf="adat.ugyfeloldal.includes(c.alr)">{{ c.nev }}{{ c.alr === 'NAPLO' ? ' (ügyfélportál, olvasás)' : '' }} </ng-container></ng-container></p>

      <h4>Cégek <small class="halvany">{{ urlap.cegek.size }} kiválasztva{{ urlap.fajta === 'munkatars' && !urlap.cegek.size ? ' – üresen minden céget lát' : '' }}{{ urlap.fajta === 'ugyfel' && !urlap.cegek.size ? ' – az ügyfélnek legalább egy cég kell' : '' }}</small></h4>
      <div class="afh-sor">
        <input class="afh-kereso" [(ngModel)]="cegSzuro" placeholder="Keresés név, adószám szerint">
        <button type="button" class="afh-link" (click)="mindKijelol(true)">mind</button>
        <button type="button" class="afh-link" (click)="mindKijelol(false)">egyik sem</button>
      </div>
      <div class="afh-cegek">
        <label *ngFor="let c of cegekSzurve" [class.inaktiv]="c.inaktiv">
          <input type="checkbox" [checked]="urlap.cegek.has(c.id)" (change)="cegValt(c.id, $any($event.target).checked)">
          <span>{{ c.nev }}<small *ngIf="c.adoszam"> · {{ c.adoszam }}</small></span>
        </label>
        <div class="halvany" *ngIf="!adat.cegek.length">Még nincs ügyfél ebben a modulban.</div>
      </div>

      <div class="afh-sor afh-lab">
        <label *ngIf="urlap.uj && adat.belepes === 'keycloak'"><input type="checkbox" [(ngModel)]="urlap.kuldes" [disabled]="!urlap.email"> belépési adatok e-mailben</label>
        <span class="spacer"></span>
        <button type="button" class="afh-gomb masod" (click)="megse()" [disabled]="fut">Mégse</button>
        <button type="button" class="afh-gomb" (click)="ment()" [disabled]="!mentheto">{{ urlap.uj ? 'Felvétel' : 'Mentés' }}</button>
      </div>
      <small class="halvany" *ngIf="urlap.uj && adat.belepes === 'keycloak'">A belépési fiók a Keycloakban készül, ideiglenes jelszóval – az első belépéskor újat kér.</small>
      <small class="halvany" *ngIf="urlap.uj && adat.belepes === 'nincs'">Jelszó nélküli standalone mód: belépési fiók nem készül.</small>
    </section>

    <!-- LISTA -->
    <section class="afh-kartya">
      <div class="afh-sor">
        <input class="afh-kereso" [(ngModel)]="kereso" placeholder="Keresés név, felhasználónév, e-mail szerint">
        <span class="spacer"></span>
        <button type="button" class="afh-gomb" (click)="ujFelhasznalo()" [disabled]="fut || !!urlap"><ion-icon name="person-add-outline"></ion-icon> Új felhasználó</button>
      </div>
      <div class="halvany" *ngIf="!felhasznalok.length">Nincs felhasználó.</div>
      <table class="afh-tabla" *ngIf="felhasznalok.length">
        <thead><tr><th>Név</th><th>Fajta</th><th>Jogkör</th><th>Cégek</th><th></th></tr></thead>
        <tbody>
          <tr *ngFor="let f of felhasznalok">
            <td><b>{{ f.nev }}</b><small>{{ f.felhasznalo }}{{ f.email ? ' · ' + f.email : '' }}</small></td>
            <td><span class="afh-cimke" [class.ugyfel]="f.fajta === 'ugyfel'">{{ f.fajta === 'ugyfel' ? 'ügyfél' : 'munkatárs' }}</span></td>
            <td>{{ f.fajta === 'ugyfel' ? '—' : jogkorSzoveg(f) }}<small *ngIf="f.tobb_jogkor">több jogkör – a mentés a meglévőket megtartja</small></td>
            <td [class.korlat]="f.korlatozott">{{ cegSzoveg(f) }}</td>
            <td class="afh-muv">
              <button type="button" class="afh-link" (click)="szerkeszt(f)" [disabled]="fut || !!urlap">kiosztás</button>
              <button type="button" class="afh-link" (click)="ujJelszo(f)" [disabled]="fut" *ngIf="adat.belepes !== 'nincs'">új jelszó</button>
              <button type="button" class="afh-link piros" (click)="megvon(f)" [disabled]="fut">megvonás</button>
            </td>
          </tr>
        </tbody>
      </table>
    </section>
  </ng-container>
</div>
